import { filter, mergeMap, of, withLatestFrom } from 'rxjs'
import { catchError, retryWhen } from 'rxjs/operators'
import { authenticationExpiredOr } from '../../../../Framework/Epic/AuthenticationExpired.js'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import type { Epic } from '../../../index.js'
import { Actions } from '../../../Slice/index.js'

export const GetAllOrderEpic: Epic = (action$, state$, { order, OrderRepository }) =>
  action$.pipe(
    filter(Actions.order.getAllOrderRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      OrderRepository.getAllOrders(action.payload, state.authentication.user).pipe(
        mergeMap((response) => of(order.getAllOrderSuccess(response))),
        retryWhen(serverIsNotAvailable()),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.getAllOrderFailure({ error }))
          })
        )
      )
    )
  )
